export type OEPRoleKey = 'presenter' | 'reviewer' | 'nominator' | 'committee' | 'staff';

/** Exact MJ role names (metadata/roles/oep-*.json). */
export const OEP_ROLE_NAMES: Readonly<Record<OEPRoleKey, string>> = {
    presenter: 'OEP Presenter',
    reviewer: 'OEP Reviewer',
    nominator: 'OEP Nominator',
    committee: 'OEP Committee',
    staff: 'OEP Staff',
};

/** Primary key of the `OEP Presenter` role (metadata/roles/oep-presenter.json). */
export const OEP_PRESENTER_ROLE_ID = '0E900000-0000-4000-9000-000000000001';

export const OEP_PARTICIPANT_ROLE_KEYS: readonly OEPRoleKey[] = ['presenter', 'reviewer', 'nominator', 'committee'];

/** Role chip label + "opens" copy (logic.js:1-7). */
export const OEP_ROLE_LABELS: Readonly<Record<OEPRoleKey, { Label: string; Opens: string }>> = {
    presenter: { Label: 'Presenter', Opens: 'opens July' },
    reviewer: { Label: 'Reviewer', Opens: 'opens November' },
    nominator: { Label: 'Session Nominator', Opens: 'nominating opens at AGU26' },
    committee: { Label: 'Section Committee', Opens: 'selection opens January' },
    staff: { Label: 'AGU Staff', Opens: 'always on' },
};

const KEY_BY_NAME = new Map<string, OEPRoleKey>(
    (Object.entries(OEP_ROLE_NAMES) as [OEPRoleKey, string][]).map(([k, v]) => [v, k]),
);

/** Exact-match role names → OEP role keys. Fails closed: unknown names are ignored. */
export function RoleKeysFromRoleNames(names: readonly string[]): ReadonlySet<OEPRoleKey> {
    const out = new Set<OEPRoleKey>();
    for (const n of names) {
        const key = KEY_BY_NAME.get(n);
        if (key) out.add(key);
    }
    return out;
}
